import React from 'react'

const SkeletonCell = ({ width }) => (
    <div style={{ width, height: "18px", backgroundColor: "#e5e7eb", borderRadius: "4px", animation: "pulse 1.5s ease-in-out infinite" }} />
);

const ItemDescription = (invoiceData) => {
    var total = 0;
    var totalCost = 0;
    const data = invoiceData.invoiceData && invoiceData.invoiceData.length > 0 ? invoiceData.invoiceData[0] : null;
    const isReimbursement = data && data.inv_type === "Reimbursement";

    return (
        <>
            <div className="table-inner-outmain22">
                <table className="invo-single-tb1">
                    <thead>
                        <tr className="mainborder-bottom">
                            <td>Item</td>
                            <td style={{ width: '40%', paddingRight: "20px" }}>Description</td>
                            <td>{isReimbursement ? "Category" : "Cost"}</td>
                            <td>VAT %</td>
                            <td>{isReimbursement ? "Amount" : "Price"}</td>
                        </tr>
                    </thead>
                    <tbody>
                        {data ? (
                            <>
                                {data.Invoice_Details.map((item, index) => {
                                    total = total + parseFloat(item.Price);
                                    totalCost = totalCost + parseFloat(item.Cost);
                                    return (
                                        <tr valign="top" className="border-bottomiteam infotablem" key={index}>
                                            <td>{index + 1}</td>
                                            <td style={{ maxWidth: "300px", paddingRight: "30px" }}>{item.Description}</td>
                                            {isReimbursement ? (<td>{item.Category}</td>) : (<td>{new Intl.NumberFormat('en-US', { style: 'currency', currency: data.inv_currency }).format(item.Cost)}</td>)}
                                            <td>{item.VAT}</td>
                                            <td>{new Intl.NumberFormat('en-US', { style: 'currency', currency: data.inv_currency }).format(item.Price)}</td>
                                        </tr>
                                    );
                                })}
                                <tr className="sub-bordertotal reborder sub-bordertotal-new">
                                    <td className="mob-no-need"></td><td className="mob-no-need"></td><td className="mob-no-need"></td>
                                    <td>Subtotal</td>
                                    <td className="tab-totalsubvat">{new Intl.NumberFormat('en-US', { style: 'currency', currency: data.inv_currency }).format(data.inv_sub_total[0])}</td>
                                </tr>
                                <tr className="vat-bordertotal reborder">
                                    <td className="mob-no-need"></td><td className="mob-no-need"></td><td className="mob-no-need"></td>
                                    <td>VAT</td>
                                    <td className="tab-totalvat">{new Intl.NumberFormat('en-US', { style: 'currency', currency: data.inv_currency }).format(data.inv_total_tax)}</td>
                                </tr>
                                <tr className="total-bordertotal reborder">
                                    <td className="mob-no-need"></td><td className="mob-no-need"></td><td className="mob-no-need"></td>
                                    <td className="invo-totalfd">Invoice Total</td>
                                    <td className="tab-totalamt">{new Intl.NumberFormat('en-US', { style: 'currency', currency: data.inv_currency }).format(data.inv_total_amount)}</td>
                                </tr>
                            </>
                        ) : (
                            <>
                                {Array.from({ length: 3 }).map((_, index) => (
                                    <tr key={`skeleton-row-${index}`} className="border-bottomiteam infotablem">
                                        <td><SkeletonCell width="20px" /></td>
                                        <td style={{ maxWidth: "300px", paddingRight: "30px" }}><SkeletonCell width="200px" /></td>
                                        <td><SkeletonCell width="80px" /></td>
                                        <td><SkeletonCell width="50px" /></td>
                                        <td><SkeletonCell width="80px" /></td>
                                    </tr>
                                ))}
                                <tr className="sub-bordertotal reborder sub-bordertotal-new">
                                    <td className="mob-no-need"></td><td className="mob-no-need"></td><td className="mob-no-need"></td>
                                    <td><SkeletonCell width="60px" /></td>
                                    <td className="tab-totalsubvat"><SkeletonCell width="80px" /></td>
                                </tr>
                                <tr className="vat-bordertotal reborder">
                                    <td className="mob-no-need"></td><td className="mob-no-need"></td><td className="mob-no-need"></td>
                                    <td><SkeletonCell width="40px" /></td>
                                    <td className="tab-totalvat"><SkeletonCell width="80px" /></td>
                                </tr>
                                <tr className="total-bordertotal reborder">
                                    <td className="mob-no-need"></td><td className="mob-no-need"></td><td className="mob-no-need"></td>
                                    <td className="invo-totalfd"><SkeletonCell width="100px" /></td>
                                    <td className="tab-totalamt"><SkeletonCell width="80px" /></td>
                                </tr>
                            </>
                        )}
                    </tbody>
                </table>
            </div>
            <style>{`
                @keyframes pulse {
                  0%, 100% { opacity: 1; }
                  50% { opacity: 0.5; }
                }
            `}</style>
        </>
    );
}

export default ItemDescription
